const navItem = document.querySelectorAll('.nav-item');

function hideNavItem () {
    navItem.forEach(item => {
        item.classList.remove("nav-item--active");
    })
};

navItem.forEach(item =>{
    item.addEventListener('mouseenter',(e) =>{ 
        hideNavItem ();
        e.target.classList.add("nav-item--active");
    })
});

function moblieSearchPlacholder(){
    const placeholderSearch = document.querySelectorAll('.search-bar');
    if(window.innerWidth <= 767){
        placeholderSearch.forEach(el => {
            el.placeholder = "Поиск по сайту";
        });
    }
    if (window.innerWidth > 767){
        placeholderSearch.forEach(el => {
            el.placeholder = "Поиск по сайту: найдется то, что нужно";
        });
    }
}

moblieSearchPlacholder();
window.addEventListener('resize', () => {
    moblieSearchPlacholder();
});
